import { mergeFilterOptions } from './learningReportFields';

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

const PAGE_ONLY_FILTER_KEYS = ['data_count', 'title', 'date_range'];

const toWholeNumber = (value, fallback) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
};

export function emptyPagination(perpage = DEFAULT_PAGE_SIZE) {
  return {
    pageno: 0,
    perpage,
    data_count: 0,
    total_pages: 0,
    has_next: false,
    has_previous: false,
  };
}

export function resolvePagination(data, requested) {
  const pagination = data?.pagination;
  if (pagination && typeof pagination === 'object') {
    return {
      pageno: toWholeNumber(pagination.pageno, requested.pageno),
      perpage: toWholeNumber(pagination.perpage, requested.perpage),
      data_count: toWholeNumber(pagination.data_count, 0),
      total_pages: toWholeNumber(pagination.total_pages, 0),
      has_next: !!pagination.has_next,
      has_previous: !!pagination.has_previous,
    };
  }
  // Backends without data.pagination still report the total in filter.data_count.
  const { pageno, perpage } = requested;
  const dataCount = toWholeNumber(data?.filter?.data_count, 0);
  const totalPages = dataCount > 0 ? Math.ceil(dataCount / perpage) : 0;
  return {
    pageno,
    perpage,
    data_count: dataCount,
    total_pages: totalPages,
    has_next: pageno < totalPages - 1,
    has_previous: pageno > 0,
  };
}

export function normalizeFilterMeta(filter) {
  if (!filter) {
    return null;
  }
  const emails = [...new Set(filter.email || [])].filter((itm) => itm);
  return { ...filter, email: emails };
}

// include_filters:false responses omit the dropdown lists and not_started_count,
// so only the report-wide summary keys are taken from them.
export function mergeReportFilterMeta(previous, filter, includeFilters) {
  if (!filter) {
    return previous;
  }
  if (includeFilters || !previous) {
    return mergeFilterOptions(previous, normalizeFilterMeta(filter));
  }
  const summary = {};
  PAGE_ONLY_FILTER_KEYS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(filter, key)) {
      summary[key] = filter[key];
    }
  });
  return { ...previous, ...summary };
}

export function outOfRangePage(pagination, rowCount) {
  if (rowCount > 0 || !pagination) return null;
  const { pageno, data_count: dataCount, total_pages: totalPages } = pagination;
  if (dataCount > 0 && totalPages > 0 && pageno > totalPages - 1) {
    return totalPages - 1;
  }
  return null;
}

const formatCount = (value) => Number(value).toLocaleString('en-US');

export function formatShowingRange(pagination, rowCount) {
  const dataCount = pagination?.data_count || 0;
  if (!dataCount) {
    return '0 results';
  }
  if (!rowCount) {
    return `Showing 0 of ${formatCount(dataCount)}`;
  }
  const offset = (pagination.pageno || 0) * (pagination.perpage || DEFAULT_PAGE_SIZE);
  return `Showing ${formatCount(offset + 1)}–${formatCount(offset + rowCount)} of ${formatCount(dataCount)}`;
}
